import type { ReactNode } from 'react';

export const symbol_gamepad_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m459-572-81-82q-5-5-7-10t-2-11v-175q0-13 8.5-21.5T399-880h163q13 0 21.5 8.5T592-850v175q0 6-2 11t-7 10l-82 82q-5 5-10 6.5t-11 1.5q-6 0-11-1.5t-10-6.5Zm113 113q-5-5-6.5-10t-1.5-11q0-6 1.5-11t6.5-10l82-82q5-5 10-7t11-2h175q13 0 21.5 8.5T880-562v163q0 13-8.5 21.5T850-369H675q-6 0-11-2t-10-7l-82-81ZM80-399v-163q0-13 8.5-21.5T110-592h175q6 0 11 2t10 7l82 82q5 5 6.5 10t1.5 11q0 6-1.5 11t-6.5 10l-82 81q-5 5-10 7t-11 2H110q-13 0-21.5-8.5T80-399Zm289 289v-175q0-6 2-11t7-10l81-82q5-5 10-6.5t11-1.5q6 0 11 1.5t10 6.5l82 82q5 5 7 10t2 11v175q0 13-8.5 21.5T562-80H399q-13 0-21.5-8.5T369-110Zm111-524 52-52v-134H429v134l51 52Zm-51 494h103v-135l-52-52-51 52v135Zm257-289h134v-103H686l-52 52 52 51Z"
		/>
	</svg>
);
